import { useCallback } from 'react';
import { useLowLevelAuthFlowMachine } from '../LowLevelAuthFlowMachineContext';
export function useAuthFlowActions() {
  const {
    send
  } = useLowLevelAuthFlowMachine();
  const handleParamChange = useCallback((name, value) => {
    send({
      type: 'UPDATE_PARAM',
      name,
      value
    });
  }, [send]);
  return {
    handleParamChange
  };
}